import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const BeautySection = ({
  title,
  button,
  language,
  ButtonUrl1,
  ButtonUrl2,
  ButtonUrl3,
  ImageUrl1,
  ImageUrl2,
  ImageUrl3,
}) => {
  const navigate = useNavigate();
  const [windowSize, setWindowSize] = useState(window.innerWidth > 991);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth > 991);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const rtlClass = language === "ar" ? "rtl-style" : "";

  return (
    <section className={`beauty-section ${rtlClass}`}>
      <div className="beauty-images">
        <div className="beauty-card" onClick={() => navigate(ButtonUrl1)}>
          <h2 className="beauty-title">{title}</h2>
          <img src={ImageUrl1} alt="beauty-1" className="beauty-img" />
          {windowSize ? (
            <button className="beauty-btn" onClick={() => navigate(ButtonUrl1)}>
              {button}
            </button>
          ) : (
            ""
          )}
        </div>
        <div className="beauty-card" onClick={() => navigate(ButtonUrl2)}>
          <img src={ImageUrl2} alt="beauty-2" className="beauty-img" />
        </div>
        <div
          className="beauty-card beauty-card-3"
          onClick={() => navigate(ButtonUrl3)}
        >
          <img src={ImageUrl3} alt="beauty-3" className="beauty-img" />
        </div>
      </div>
    </section>
  );
};

export default BeautySection;
